<template>
  <div class="auth-result">
    <div class="auth-result__text-content">
      <div class="auth-result__title">
        <TypographyComp
          v-editor-inline="'Авторизация_успех_заг'"
          preset="heading-m"
        />
      </div>

      <div class="auth-result__description">
        <TypographyComp
          v-editor-inline="'Авторизация_успех_текст'"
          preset="text-s"
        />
      </div>
    </div>

    <CommonButton
      @click="handleClick"
    >
      <TypographyComp
        v-editor-inline="'Авторизация_успех_кнопка'"
        preset="text-m"
      />
    </CommonButton>
  </div>
</template>

<script setup lang="ts">
import { usePopup } from '@common/composables/usePopup';

const { closePopup } = usePopup();

const handleClick = (): void => {
  closePopup();
};
</script>

<style lang="scss" scoped>
.auth-result {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 32rem;
  margin: 0 auto;
  gap: 2.8rem;

  &__title {
    text-align: center;
  }

  &__text-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.6rem;
  }

  &__description {
    text-align: center;
  }
}
</style>
